var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"container-fluid card-body",staticStyle:{"padding":"0px"}},[_c('tableBtns')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header",staticStyle:{"padding":"0.25rem 1.25rem"}},[_c('h3',{staticStyle:{"margin-bottom":"0px"}},[_c('strong',{staticClass:"text-info",staticStyle:{"font-size":"32px"}},[_vm._v(" Btn Call Link ")])])])
}]

export { render, staticRenderFns }